import {Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy, Input} from '@angular/core';
import * as XLSX from 'xlsx';
import { StateService } from 'app/core/state.service';
import { Subject } from 'rxjs/Subject';

type AOA = any[][];

@Component({
    selector: 'spreadsheet',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
<div class="spreadsheet_content">
    <input type="file" id="input-file-id" hidden (change)="onFileChange($event)" accept=".xlsx,.xls,.csv">
    <div *ngIf="data_loaded" class="import_panel">
        <p>Double check we've got your data in the right columns: <span>(First 3 lines of data shown)</span></p>
        <div class="columns">
            <div class="column" *ngFor="let d of data[0]; let i=index">
                <mat-form-field>
                    <mat-select [(ngModel)]="column_fields[i]" (change)="columnAssigned($event)">
                        <mat-option *ngFor="let fd of fields" [value]="fd.value" [disabled]="isAssigned(fd.value)">{{fd.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="preview">
                    <div class="row" *ngFor="let row of data | slice:0:3">
                        <div class="cell">{{row[i]}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="controls">
            <div *ngIf="has_unique_id && !use_custom_id" class="note">
                Choosing to import Unique Identifiers means that you can scan QRcodes that correspond. But it also means that you are responsible for keeping the IDs unique.
            </div>
            <button mat-button (click)="cancel()">CANCEL</button>
            <button class="import_btn" [disabled]="!fieldsfilled" (click)="save()">IMPORT</button>
        </div>
    </div>
</div>
    `,
    styles: [`
        .spreadsheet_content { width:100%; padding: 0 10px 10px; background: #fff; }
        .spreadsheet_content .preview { margin:0 0 20px 0; color:#333;  }
        .spreadsheet_content .import_panel { background: #EEF2F5; font-family: Ubuntu; font-size: 14px; color: #333; 
            border-radius:10px; overflow:hidden}
        .spreadsheet_content .import_panel p { margin:20px; }
        .spreadsheet_content .columns { display: flex; flex-flow: wrap; }
        .spreadsheet_content .column:nth-child(4n-3) { padding:0 20px 20px; }
        .spreadsheet_content .column { width:25%; padding:0 20px 20px 0; }
        .spreadsheet_content .column /deep/ .mat-form-field { width:100%; margin-bottom: 15px; }
        .spreadsheet_content .column /deep/ .mat-form-field-wrapper { background: #fff; padding-bottom: 10px; }
        .spreadsheet_content .column /deep/ .mat-form-field-underline { height:0; }
        .spreadsheet_content .column /deep/ .mat-select { padding:0 10px; }
        .spreadsheet_content .row { padding-bottom: 5px; color: #999; }
        .spreadsheet_content .cell { flex:1; }
        .spreadsheet_content .drop_panel { background: #EEF2F5; border-radius:5px; overflow: hidden;text-align: center; }
        .spreadsheet_content .drop_panel .square { padding:10px; }
        .spreadsheet_content .drop_panel label mat-icon { color:#999; font-size:48px; width:48px; height:48px; }
        .spreadsheet_content .drop_panel label span { color:#999; }
        .spreadsheet_content .drop_panel label { background: #EEF2F5; display: block; font-family: Ubuntu; 
            font-size: 14px; color: #333; border:2px dashed #ddd; border-radius:5px; }
        .spreadsheet_content .drop_panel label #drop_zone { padding: 30px 0; }
        .controls { border-top:1px solid #ddd; padding: 20px 0; margin: 0 20px; display: flex; align-items: center; flex-direction: row; justify-content: flex-end; }
        .controls button { color:#999; }
        .controls .import_btn:disabled { background:#999; }
        .note {	display: inline-block; background: #EE2255; padding: 10px 30px; margin-left: 10px; font-size: 14px; letter-spacing: 1px; border: 1px solid #ddd; border-radius: 5px; margin: 0 5px; cursor: pointer; position: relative; z-index: 5; max-width: 500px; color: #fff; text-align: left;}
        .controls .import_btn { width: 170px; line-height: 50px; background: #2255FF; color: #fff; 
            font-family: "ff-netto-web",sans-serif; font-size: 16px; letter-spacing: 1px; border-radius: 25px; }

    `]
})
export class SpreadsheetComponent implements OnInit {

    data: AOA;
    has_unique_id: boolean = false;
    readonly fields = [
        {value: 'ignore', label: 'Ignore'},
        {value: 'email', label: 'Email'},
        {value: 'firstName', label: 'First Name'},
        {value: 'lastName', label: 'Last Name'},
        {value: 'company', label: 'Company'},
        {value: 'phone', label: 'Phone'},
        {value: 'uid', label: 'Unique ID'}
    ];
    column_fields = [];
    // @Output() valueChange = new EventEmitter<any>();
    @Output() action = new EventEmitter<any>();
    @Input() use_custom_id:boolean = false;

    data_loaded = false;

    afterSave: Subject<string> = new Subject();

    get fieldsfilled() {
        return this.column_fields.findIndex( x => x == 'email') > -1 &&
            this.column_fields.findIndex( x => x == 'firstName') > -1 &&
            this.column_fields.findIndex( x => x == 'lastName') > -1;
    }


    constructor(public state:StateService) {
        this.afterSave.subscribe( cmd => {
            if (cmd === 'saved') {
                console.log('saved, doing clean');
                this.data = null;
                this.column_fields = [];
            }
        });
    }
    ngOnInit() {
    }
    isAssigned(fd) {
        return this.column_fields.findIndex(x => x == fd && fd != 'ignore') > -1;
    }
    dragover(ev) {
        // console.log('dragover', ev);
        ev.preventDefault();
    }
    drop(ev) {
        ev.preventDefault();
        // const target: DataTransfer = <DataTransfer>(ev.target);
        console.log('drop', ev);
        if (ev.dataTransfer.items.length==1) {
            const file = ev.dataTransfer.items[0].getAsFile();
            console.log('... file.name = ' + file.name);
        }
    }

    columnAssigned($event){
        this.has_unique_id = (this.column_fields.indexOf('uid') > -1)
    }

    onFileChange(evt: any) {
        var targetFile: File;
        if (evt.dataTransfer && evt.dataTransfer.files.length == 1) {
            targetFile = evt.dataTransfer.files[0];
        } else if (evt.target.files && evt.target.files.length == 1 ) {
            targetFile = evt.target.files[0];
        } else {
            throw new Error('Cannot use multiple files');
        }

        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            this.data_loaded = true;
            /* read workbook */
            const bstr: string = e.target.result;
            const wb:any = XLSX.read(bstr, {type: 'binary'});

            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws:any = wb.Sheets[wsname];

            /* save data */
            this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
            let first_row_is_labels = false;
            let first_row_has_at_symbol = false;
            let column_fields = [];
            let mini_keys = this.fields.map(k=>k.value.replace(' ','').toLowerCase());
            this.data[0].forEach( d => {
                if(/@/.test(d)) first_row_has_at_symbol = true;
                let minified = d.replace(' ','').toLowerCase();
                let k_idx = mini_keys.indexOf(minified);
                if( k_idx > -1) {
                    first_row_is_labels = true;
                    column_fields.push(this.fields[k_idx].value)
                }else if(/@/.test(d) || /@/.test(this.data[1][column_fields.length])){
                    column_fields.push('email');
                }else{
                    column_fields.push('ignore');
                }
            });

            if(first_row_is_labels || !first_row_has_at_symbol){ this.data.shift();  }
            this.column_fields = column_fields;
        };
        reader.readAsBinaryString(targetFile);
    }
    cancel() {
        this.data = null;
        const obj = {};
        obj['action'] = 'cancel';
        this.action.emit(obj);
    }
    save() {
        const obj = {};
        obj['action'] = 'save';
        obj['data'] = this.data;
        obj['column_fields'] = this.column_fields;
        obj['afterSave'] = this.afterSave;
        this.action.emit(obj);
        this.data_loaded = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/components/spreadsheet.component.ts